module.exports = function createNetworkError(operation, json) {
    const error = new Error('DibsRelayNetworkLayer');
    const errorsMessage = json.errors
        ? json.errors.map(({ message }) => message).join('\n')
        : '(No errors)';

    error.message = `No data returned for operation '${operation.name}' got error(s):\n${errorsMessage}\n\nSee the error 'source' property for more information.`;

    error.source = {
        errors: json.errors,
    };

    return error;
};
